import axios from 'axios';
import { getSessionToken, getStoreInfo, goTo } from '@tiendanube/nexo';
import nexo from '../nexoClient';
import { navigateTo } from './navigation';

const apiInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URI}`,
});

apiInstance.interceptors.request.use(async (request) => {
  const token = await getSessionToken(nexo);
  const store = await getStoreInfo(nexo);
  const bearerToken = `Bearer ${token}`;
  request.headers = {
    ...request.headers,
    Authorization: bearerToken,
    'Store-Country': `${store.country}`,
    'x-store-id': `${store.id}`,
  } as any; // eslint-disable-line @typescript-eslint/no-explicit-any
  return request;
});

apiInstance.interceptors.response.use(
  (response) => response, // Deixar respostas bem-sucedidas inalteradas
  (error) => {
    // Logar o erro para depuração
    console.error('Erro na API:', error);

    if (error.response) {
      const status = error.response.status;
      const errorCode = error.response.data?.error?.code;

      console.error('Detalhes do erro:', error.response.data);
      console.error('Detalhes do erro:', errorCode);

      // Tratar erros específicos automaticamente
      switch (status) {
        case 400:
          switch (errorCode) {
            case 'STORE_PROFILE_INCOMPLETE':
              // Redirecionar para página de configuração
              console.log('Redirecionando para página de configuração');
              navigateTo('/billing');
              break;
            case 'APP_NOT_PAID':
              // Redirecionar para página de billing
              navigateTo('/billing');
              break;
          }
          break;
        case 404:
          if (errorCode === 'STORE_NOT_FOUND') {
            // Redirecionar para URL de instalação
            redirectToInstall();
          }
          break;
        case 401:
          if (errorCode === 'APP_NOT_INSTALLED') {
            // Redirecionar para URL de instalação
            redirectToInstall();
          }
          break;
        case 402:
          // Redirecionar para página de billing
          navigateTo('/billing');
          break;
      }
    }

    // Rejeitar a promessa com o erro para que possa ser tratado no `catch`
    return Promise.reject(error);
  },
);

/**
 * Redireciona para a URL de instalação usando o Nexo
 */
const redirectToInstall = (): void => {
  // Usar o goTo do Nexo para redirecionar para a URL de instalação
  // Isso funciona corretamente dentro do iframe do Nuvemshop
  goTo(nexo, `/apps/${process.env.REACT_APP_REAL_ID}/authorize`);
};

export default apiInstance;
